<template>
  <span
      v-if="count > 0"
      class="absolute box-border flex items-center justify-center rounded-full bg-secondary-900 text-white font-bold leading-none border-2"
      :class="[positionClass, borderColorClass, count > 9 ? 'text-[8px]' : 'text-2']"
      style="width: 18px; height: 18px; direction: ltr;"
  >{{ display }}</span>
</template>

<script lang="ts" setup>
interface Props {
  count: number
  positionClass?: string
  borderColorClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  positionClass: '-top-1 -right-2',
  borderColorClass: 'border-gray-900'
})

const display = computed(() => props.count > 9 ? '+9' : String(props.count))
</script>
